module.exports = {
    apiKey: 'AIzaSyD6l9UxCVcTVSYzRYAd0REB6_94qIDuqMs',
    authDomain: 'cellwine-test.firebaseapp.com',
    databaseURL: 'https://cellwine-test.firebaseio.com',
    storageBucket: 'cellwine-test.appspot.com',
    messagingSenderId: '876006090150'
}